import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'
import { useLegalModal } from '../data-display/LegalModalContext.tsx'
import { Checkbox } from './Checkbox.tsx'

const CheckboxTermsAndPrivacy = ({
  isTermsAccepted,
  setIsTermsAccepted,
}: {
  isTermsAccepted: boolean
  setIsTermsAccepted: (isTermsAccepted: boolean) => void
}) => {
  const { openModal } = useLegalModal()

  return (
    <div className="flex items-center">
      <Checkbox
        id="terms"
        checked={isTermsAccepted}
        onCheckedChange={() => setIsTermsAccepted(!isTermsAccepted)}
        className="z-10 border-neutral-100"
        color="gamaNeutral"
      />
      <label htmlFor="terms" className="ml-2 text-base-medium">
        Acepto los{' '}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault()
            openModal('terminos-y-condiciones')
          }}
          className="underline"
        >
          términos y condiciones
        </button>{' '}
        y la{' '}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault()
            openModal('politica-de-privacidad')
          }}
          className="underline"
        >
          política de privacidad
        </button>
      </label>
    </div>
  )
}

CheckboxTermsAndPrivacy.displayName = CheckboxPrimitive.Root.displayName

export { CheckboxTermsAndPrivacy }
